import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import { env } from '../../config';

import {
  PageAssignment,
  PageAssignments,
  PageListAssignments,
} from '../pages/assignments';

const RouteAssignments = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        {env.user.roles.includes('admin') ? (
          <PageAssignments />
        ) : (
          <PageListAssignments />
        )}
      </Route>
      <Route path={`${path}/:_id`}>
        <PageAssignment />
      </Route>
    </Switch>
  );
};

export default RouteAssignments;
